import dayjs from 'dayjs'

import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import CardActionArea from '@mui/material/CardActionArea'
import Chip from '@mui/material/Chip'
import Stack from '@mui/material/Stack'
import MonitorHeartIcon from '@mui/icons-material/MonitorHeart'

import colors from '@/assets/scss/_themes-vars.module.scss'

type HealthDataProps = {
  consultationId: string
  /**
   * date must be ISO string
   */
  date: string
  /**
   * Callback fired when health data box is clicked
   */
  onClick?: (consultationId: string) => void
}

export function HealthData(props: HealthDataProps) {
  const { consultationId, date, onClick } = props

  const handleClick = () => {
    onClick?.(consultationId)
  }

  return (
    <Box sx={[{ maxWidth: 280 }]}>
      <Card sx={{ width: '100%', borderRadius: '8px', border: `1px solid ${colors.gray300}` }} elevation={0}>
        <CardActionArea
          onClick={handleClick}
          sx={{
            width: '100%',
            position: 'relative',
            background: '#FFF',
            borderRadius: '8px',
            cursor: 'pointer',
          }}
        >
          <Box component="div" sx={{ pt: '70%', position: 'relative' }}>
            <Stack
              alignItems="center"
              justifyContent="center"
              spacing={1}
              sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}
            >
              <MonitorHeartIcon htmlColor={colors.indigo700} />
              <Chip
                color="primary"
                label={dayjs(date).isValid() ? dayjs(date).format('DD/MM/YYYY') : ''}
                size="small"
                variant="filled"
                sx={{
                  cursor: 'pointer',
                  overflow: 'visible',
                  minWidth: 'fit-content', // Adjust as needed
                  padding: '4px 10px', // Adjust as needed
                  boxSizing: 'border-box',
                }}
              />
            </Stack>
          </Box>
        </CardActionArea>
      </Card>
    </Box>
  )
}

export default HealthData
